export default __webpack_public_path__ + "static/media/vib_1.aa900ea8.png";